import React from "react";

const OtherSignupLinks = () => (
    <div className="margin-t-xxl margin-b-l color-grey">
        <a href="/accounts/create-team" className="plan-team">
            Team Pricing
        </a>
        <br />
        <br />
        <a href="/for-edu/login" className="plan-pro">
            Education Pricing
        </a>
    </div>
);

export default OtherSignupLinks;
